module.exports = __webpack_public_path__ + "static/media/hipotecaria.c2f7bb8a.png";